import { CheckCircleIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import type { SECTION_CATALOG } from "./catalog";

type Suggestion = (typeof SECTION_CATALOG)[number];
type Props = {
  suggestion: Suggestion;
  selected: boolean;
  added: boolean;
  onSelect: () => void;
};

export const SectionChoice = ({ suggestion, selected, added, onSelect }: Props) => {
  const Icon = suggestion.icon;
  return (
    <button
      type="button"
      disabled={added}
      aria-pressed={selected}
      onClick={onSelect}
      className={cn(
        "relative flex min-h-[92px] items-start gap-3 rounded-xl border p-3 text-left transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
        selected
          ? "border-emerald-500 bg-emerald-50/60"
          : "border-slate-200 bg-white hover:-translate-y-0.5 hover:border-indigo-300 hover:shadow-sm",
        added &&
          "cursor-not-allowed bg-slate-50 opacity-55 hover:translate-y-0 hover:border-slate-200 hover:shadow-none",
      )}
    >
      <span
        className={cn(
          "grid size-9 shrink-0 place-items-center rounded-lg",
          selected ? "bg-emerald-100 text-emerald-600" : "bg-indigo-50 text-indigo-700",
        )}
      >
        <Icon size={20} weight="duotone" />
      </span>
      <span className="min-w-0 pr-4">
        <span className="block text-xs font-bold text-[#071451]">{suggestion.name}</span>
        <span className="mt-1 block text-[10px] leading-4 text-slate-500">
          {added ? "Déjà ajoutée au CV" : suggestion.description}
        </span>
      </span>
      {(selected || added) && (
        <CheckCircleIcon
          size={18}
          weight="fill"
          className={cn(
            "absolute right-2.5 top-2.5",
            added ? "text-slate-300" : "text-emerald-500",
          )}
        />
      )}
    </button>
  );
};
